import styled from 'styled-components';

const TicketFormContainer = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  form {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    position: relative;
  }
`;

export default TicketFormContainer;
